// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;44</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;We have heard with our ears, O God, our forebears have told us,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;all that you did in their days, in time of old;<br> </p> </div></div>";
// Exports
module.exports = code;